import { c as _c } from "react/compiler-runtime";
export const ChatKitArrowIcon = props => {
  const $ = _c(3);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <path d="M30.0579 13.9545C30.6435 14.5401 30.6435 15.4894 30.0579 16.075L21.0604 26.0608C20.4748 26.6464 19.5255 26.6464 18.9399 26.0608L9.94249 16.075C9.35687 15.4894 9.35687 14.5401 9.94249 13.9545C10.5281 13.3689 11.4292 13.3601 12.063 13.9545L18.9515 19.6094C19.3115 19.9049 19.4915 20.0527 19.6921 20.1096C19.8689 20.1597 20.0561 20.1602 20.2332 20.1108C20.434 20.0549 20.6147 19.908 20.9761 19.6142L27.9374 13.9545C28.5504 13.329 29.4722 13.3689 30.0579 13.9545Z" fill="white" />;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  let t1;
  if ($[1] !== props) {
    t1 = <svg width="40" height="40" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>{t0}</svg>;
    $[1] = props;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  return t1;
};